/**
 * Upload History Constants
 * Centralized configuration for colors, sizes, and magic numbers
 */

// Status Configuration
export const UPLOAD_STATUS = {
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  COMPLETED_WITH_ERRORS: 'completed_with_errors',
  FAILED: 'failed',
};

// Template Types
export const TEMPLATE_TYPES = {
  TEMPLATE_1: 'template-1',
  TEMPLATE_2: 'template-2',
};

// Status Colors (Material Design Color System)
export const STATUS_COLORS = {
  [UPLOAD_STATUS.PROCESSING]: '#1976d2', // Blue 700
  [UPLOAD_STATUS.COMPLETED]: '#2e7d32', // Green 800
  [UPLOAD_STATUS.COMPLETED_WITH_ERRORS]: '#ef6c00', // Orange 800
  [UPLOAD_STATUS.FAILED]: '#c62828', // Red 800
  DEFAULT: '#757575', // Grey 600
};

// Status Icons
export const STATUS_ICONS = {
  [UPLOAD_STATUS.PROCESSING]: 'mdi-clock-outline',
  [UPLOAD_STATUS.COMPLETED]: 'mdi-check-circle',
  [UPLOAD_STATUS.COMPLETED_WITH_ERRORS]: 'mdi-alert-circle',
  [UPLOAD_STATUS.FAILED]: 'mdi-close-circle',
  DEFAULT: 'mdi-help-circle',
};

// Gradient Backgrounds for Statistics Cards
export const STAT_CARD_GRADIENTS = {
  ALL: 'linear-gradient(135deg, #1565C0 0%, #1976d2 100%)',
  SUCCESS: 'linear-gradient(135deg, #2e7d32 0%, #43a047 100%)',
  WARNING: 'linear-gradient(135deg, #ef6c00 0%, #fb8c00 100%)',
  ERROR: 'linear-gradient(135deg, #c62828 0%, #e53935 100%)',
};

// Shadow Configurations
export const STAT_CARD_SHADOWS = {
  ALL: '0 8px 32px rgba(21, 101, 192, 0.3)',
  SUCCESS: '0 8px 32px rgba(46, 125, 50, 0.3)',
  WARNING: '0 8px 32px rgba(239, 108, 0, 0.3)',
  ERROR: '0 8px 32px rgba(198, 40, 40, 0.3)',
};

// File Size Thresholds (in bytes)
export const FILE_SIZE = {
  LARGE_FILE_THRESHOLD: 10 * 1024 * 1024, // 10MB
  ZERO: 0,
};

// Duration Thresholds (in seconds) for color coding
export const DURATION_THRESHOLDS = {
  VERY_FAST: 2,
  NORMAL: 5,
  SLOW: 10,
};

// Duration Colors
export const DURATION_COLORS = {
  VERY_FAST: '#2e7d32', // Green
  NORMAL: '#1976d2', // Blue
  SLOW: '#ef6c00', // Orange
  VERY_SLOW: '#c62828', // Red
};

// Pagination
export const PAGINATION = {
  DEFAULT_ITEMS_PER_PAGE: 20,
  ITEMS_PER_PAGE_OPTIONS: [10, 20, 50, 100],
  DEFAULT_FETCH_LIMIT: 100,
};

// Search & Filter
export const SEARCH_DEBOUNCE_MS = 300;
export const MIN_SEARCH_LENGTH = 0;

// UI Sizes
export const UI_SIZES = {
  HEADER_AVATAR: 40,
  USER_AVATAR: 32,
  STAT_ICON_AVATAR: 64,
  STATUS_CHIP_MIN_WIDTH: 150,
  STATUS_CHIP_HEIGHT: 44,
};

// Animation Durations (in milliseconds)
export const ANIMATION = {
  TRANSITION_FAST: 200,
  TRANSITION_NORMAL: 300,
  TRANSITION_SLOW: 400,
  FADE_IN: 500,
};

// Responsive Breakpoints (matches Vuetify)
export const BREAKPOINTS = {
  XS: 600,
  SM: 960,
  MD: 1264,
  LG: 1904,
};

// API & Data
export const DATA_REFRESH_INTERVAL = null; // Set to number (ms) for auto-refresh

// Error Messages
export const ERROR_MESSAGES = {
  LOAD_HISTORY_FAILED: 'ไม่สามารถโหลดประวัติการอัปโหลดได้',
  REFRESH_FAILED: 'ไม่สามารถรีเฟรชข้อมูลได้',
  INVALID_DATA: 'ข้อมูลไม่ถูกต้อง',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  REFRESH_SUCCESS: 'รีเฟรชข้อมูลสำเร็จ',
  FILTERS_CLEARED: 'ล้างตัวกรองทั้งหมดแล้ว',
};

// Table Headers Configuration
export const TABLE_HEADERS = [
  {
    text: 'วันที่อัปโหลด',
    value: 'uploadedAt',
    sortable: true,
    width: '180px',
  },
  {
    text: 'ผู้อัปโหลด',
    value: 'uploadedBy',
    sortable: true,
    width: '200px',
  },
  {
    text: 'ไฟล์',
    value: 'fileInfo',
    sortable: false,
    width: '250px',
  },
  {
    text: 'Template',
    value: 'templateType',
    align: 'center',
    sortable: true,
    width: '140px',
  },
  {
    text: 'สถานะ',
    value: 'status',
    align: 'center',
    sortable: true,
    width: '160px',
  },
  {
    text: 'ผลลัพธ์',
    value: 'counts',
    align: 'center',
    sortable: false,
    width: '150px',
  },
  {
    text: 'ระยะเวลา',
    value: 'duration',
    align: 'center',
    sortable: true,
    width: '110px',
  },
  {
    text: 'จัดการ',
    value: 'actions',
    width: '90px',
    align: 'center',
    sortable: false,
  },
];

export default {
  UPLOAD_STATUS,
  TEMPLATE_TYPES,
  STATUS_COLORS,
  STATUS_ICONS,
  STAT_CARD_GRADIENTS,
  STAT_CARD_SHADOWS,
  FILE_SIZE,
  DURATION_THRESHOLDS,
  DURATION_COLORS,
  PAGINATION,
  SEARCH_DEBOUNCE_MS,
  MIN_SEARCH_LENGTH,
  UI_SIZES,
  ANIMATION,
  BREAKPOINTS,
  DATA_REFRESH_INTERVAL,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
  TABLE_HEADERS,
};
